import MenuIcon from "@mui/icons-material/Menu";
import { StyledIconButton } from "./styles";
import type {IconButtonProps} from "@mui/material/IconButton";

interface Props
  extends Pick<
    IconButtonProps,
    | "onClick"
    | "onKeyDown"
    | "role"
    | "tabIndex"
    | "aria-label"
    | "aria-expanded"
    | "aria-controls"
  > {}

export default function HamburgerMenu(props: Props) {
  return (
    <>
      <StyledIconButton
        size="large"
        edge="start"
        color="inherit"
        aria-label="open drawer"
        sx={{marginTop: "auto", marginBottom: "auto"  }}
        {...props}
      >
        <MenuIcon />
      </StyledIconButton>
    </>
  );
}
